define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 颜色渲染类型。
     *
     * @exports EnumColorMode
     * 
     * @see VectorGraphSymbol#colorMode
     */
    var EnumColorMode = {
        /**
         * 原始颜色。
         * @type {String}
         * @constant
         */
        ORIGINAL: "ORIGINAL_COLOR",

        /**
         * 翻转颜色。
         * @type {Strng}
         * @constant
         */
        REVERSE: "REVERSE_COLOR",

        /**
         * 自定义颜色。
         * @type {String}
         * @constant
         */
        CUSTOM: "CUSTOM_COLOR"
    }
    freezeObject(EnumColorMode)
    /**
     * 反向查找颜色渲染的类型。
     * 
     * @param {Number} value 颜色渲染的数值。
     * @returns {String} 颜色渲染的名称。
     */
    function getName(value) {
        for (var key in EnumColorMode) {
            if (EnumColorMode.hasOwnProperty(key) && EnumColorMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        ORIGINAL: "ORIGINAL_COLOR",
        REVERSE: "REVERSE_COLOR",
        CUSTOM: "CUSTOM_COLOR",
        getName: getName
    }
})